export default __webpack_public_path__ + "static/media/beach.6238d0d6.webp";